<button (click)="buttonClick.emit()">
  <mat-icon svgIcon="chevron-left"></mat-icon>
  <span class="back-label">Back</span>
</button>
